import $ from 'jquery';

/**
 * Handle multi-dropdown menus
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const submenuButton of $collection) {

		const $submenuButton = $(submenuButton);

		$submenuButton.on('click.multi-dropdown', () => {
			if (!$submenuButton.next().hasClass('show')) {
				$submenuButton.parents('.dropdown-menu').first().find('.show').removeClass('show');
			}
			const $subMenu = $submenuButton.next('.dropdown-menu');
			$subMenu.toggleClass('show');

			return false;
		});
	}
};